import P, { getCurrentScope as x, onScopeDispose as S, unref as A, isRef as w, toRefs as C, customRef as O, onMounted as F, nextTick as W, getCurrentInstance as M, toRef as V, readonly as G, ref as L } from "vue";
P.util.warn;
function I(e) {
  return x() ? (S(e), !0) : !1;
}
function d(e) {
  return typeof e == "function" ? e() : A(e);
}
const N = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const R = (e) => e != null, _ = Object.prototype.toString, q = (e) => _.call(e) === "[object Object]", f = () => {
};
function T(e, r) {
  function n(...t) {
    return new Promise((u, o) => {
      Promise.resolve(e(() => r.apply(this, t), { fn: r, thisArg: this, args: t })).then(u).catch(o);
    });
  }
  return n;
}
function $(e, r = {}) {
  let n, t, u = f;
  const o = (i) => {
    clearTimeout(i), u(), u = f;
  };
  return (i) => {
    const a = d(e), l = d(r.maxWait);
    return n && o(n), a <= 0 || l !== void 0 && l <= 0 ? (t && (o(t), t = null), Promise.resolve(i())) : new Promise((s, y) => {
      u = r.rejectOnCancel ? y : s, l && !t && (t = setTimeout(() => {
        n && o(n), t = null, s(i());
      }, l)), n = setTimeout(() => {
        t && o(t), t = null, s(i());
      }, a);
    });
  };
}
function b(...e) {
  let r = 0, n, t = !0, u = f, o, c, i, a, l;
  !w(e[0]) && typeof e[0] == "object" ? { delay: c, trailing: i = !0, leading: a = !0, rejectOnCancel: l = !1 } = e[0] : [c, i = !0, a = !0, l = !1] = e;
  const s = () => {
    n && (clearTimeout(n), n = void 0, u(), u = f);
  };
  return (v) => {
    const p = d(c), g = Date.now() - r, m = () => o = v();
    return s(), p <= 0 ? (r = Date.now(), m()) : (g > p && (a || !t) ? (r = Date.now(), m()) : i && (o = new Promise((h, D) => {
      u = l ? D : h, n = setTimeout(() => {
        r = Date.now(), t = !0, h(m()), s();
      }, Math.max(0, p - g));
    })), !a && !n && (n = setTimeout(() => t = !0, p)), t = !1, o);
  };
}
function z(e, r, n = !1) {
  return r.reduce((t, u) => (u in e && (!n || e[u] !== void 0) && (t[u] = e[u]), t), {});
}
function k(e) {
  return M();
}
function B(...e) {
  if (e.length !== 1)
    return V(...e);
  const r = e[0];
  return typeof r == "function" ? G(O(() => ({ get: r, set: f }))) : L(r);
}
function H(e, r = 200, n = {}) {
  return T(
    $(r, n),
    e
  );
}
function J(e, r = 200, n = !1, t = !0, u = !1) {
  return T(
    b(r, n, t, u),
    e
  );
}
function K(e, r = {}) {
  if (!w(e))
    return C(e);
  const n = Array.isArray(e.value) ? Array.from({ length: e.value.length }) : {};
  for (const t in e.value)
    n[t] = O(() => ({
      get() {
        return e.value[t];
      },
      set(u) {
        var o;
        if ((o = d(r.replaceRef)) != null ? o : !0)
          if (Array.isArray(e.value)) {
            const i = [...e.value];
            i[t] = u, e.value = i;
          } else {
            const i = { ...e.value, [t]: u };
            Object.setPrototypeOf(i, Object.getPrototypeOf(e.value)), e.value = i;
          }
        else
          e.value[t] = u;
      }
    }));
  return n;
}
function Q(e, r = !0, n) {
  k() ? F(e, n) : r ? e() : W(e);
}
export {
  I as a,
  Q as b,
  K as c,
  R as d,
  J as e,
  B as f,
  N as g,
  q as i,
  f as n,
  z as o,
  d as t,
  H as u
};
